// extracted by mini-css-extract-plugin
module.exports = {"notInteractive":"styles_notInteractive__Duu_N"};